var path = '/templates/zenclerk_s/layout/layout_main.html';
var html = "<div class=zenclerk-zcs-container><div class=ui-view-container><div class=ui-view-page-content><zcs-main></zcs-main></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/layout/layout_main.html
// module id = 1368
// module chunks = 0